import React from "react";
import PropTypes from "prop-types";

const NumberInput = ({
  name,
  id,
  label,
  value,
  type = "number",
  handleChange,
  placeholder,
  required = false,
  disabled = false,
  errorMessage,
}) => {
  return (
    <div>
      <label
        class="form-label col-form-label col-md-3 w-100 fs-5 inmate-label"
        // style={{ color: "#20252aa6", fontWeight: "400" }}
      >
        {label} {required && <span className="text-danger">*</span>}
      </label>
      <div>
        <input
          type={type}
          class="form-control mb-5px fs-5"
          placeholder={placeholder}
          name={name}
          id={id}
          value={value}
          onChange={handleChange}
          required={required}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

NumberInput.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.object,
};

NumberInput.defaultProps = {
  placeholder: "",
  required: false,
  disabled: false,
  errorMessage: {},
  id: "",
};

export default NumberInput;
